import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { withOktaAuth } from '@okta/okta-react';
import log from '../logger';
import { Spinner } from '@nike/podium';
const LoginComponent = (props) => {
    const [authenticated, setAuthenticated] = useState(null);
    useEffect(() => {
        const callAuth = async () => {
            const isOnLogin = window.location.pathname === '/login';
            if (!authenticated && isOnLogin) {
                try {
                    await props.oktaAuth.signInWithRedirect();
                }
                catch (err) {
                    log.error('Okta redirect error:', err);
                }
            }
        };
        callAuth();
    }, [authenticated, props.oktaAuth]);
    useEffect(() => {
        const setAuth = async () => {
            log.info('AUTHENTICATION', props);
            if (!props.oktaAuth)
                return;
            try {
                const isAuthenticated = await props.oktaAuth.isAuthenticated();
                setAuthenticated(isAuthenticated);
            }
            catch (error) {
                log.error('Okta isAuthenticated error:', error);
            }
        };
        setAuth();
    }, [props.oktaAuth]);
    if (!authenticated) {
        return _jsx(Spinner, {});
    }
    return _jsx("div", { children: authenticated && props.children });
};
// Remove Redux connect for isolation
export default withOktaAuth(LoginComponent);
